import { OrderDirection } from "@/constants/orderDirection";
import {
  FilterKey,
  TabKey,
} from "@/routes/_staff/people/_list/workforce/-constants";
import type { EnumUnion } from "@dresscode-frontend/utility-types";
import { z } from "zod";
import { DeviceGenreFilterKey } from "../inventory/-constants";

export const Columns = {
  WORKER_TYPE: "WORKER_TYPE",
  PERSON_NAME: "PERSON_NAME",
  DEVICE: "DEVICE",
  JOB_TYPE: "JOB_TYPE",
  DEPARTMENT: "DEPARTMENT",
  POSITION: "POSITION",
  PLACE: "PLACE",
  JOINED_ON: "JOINED_ON",
  LEFT_ON: "LEFT_ON",
  ACTION: "ACTION",
} as const;
export type Columns = EnumUnion<typeof Columns>;

export const SearchSchema = z.object({
  orderDirection: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  menu: z.nativeEnum(TabKey).default(TabKey.EMPLOYEE),
  category: z.nativeEnum(FilterKey).default(FilterKey.EMPLOYEE_ALL),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  genres: z.array(z.nativeEnum(DeviceGenreFilterKey)).optional(),
  placeIds: z.array(z.string()).optional(),
  freeText: z.string().optional(),
  sortColumn: z
    .enum([
      Columns.WORKER_TYPE,
      Columns.PERSON_NAME,
      Columns.JOB_TYPE,
      Columns.PLACE,
      Columns.JOINED_ON,
      Columns.LEFT_ON,
    ])
    .optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});
export type SearchSchema = z.infer<typeof SearchSchema>;
